import { render, staticRenderFns } from "./ourServicePesticide.vue?vue&type=template&id=d82f533e&scoped=true&"
import script from "./ourServicePesticide.vue?vue&type=script&lang=js&"
export * from "./ourServicePesticide.vue?vue&type=script&lang=js&"
import style0 from "./ourServicePesticide.vue?vue&type=style&index=0&id=d82f533e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d82f533e",
  null
  
)

export default component.exports